import { render, staticRenderFns } from "./TopNine.vue?vue&type=template&id=c96e4b1a&scoped=true&"
import script from "./TopNine.vue?vue&type=script&lang=js&"
export * from "./TopNine.vue?vue&type=script&lang=js&"
import style0 from "./TopNine.vue?vue&type=style&index=0&id=c96e4b1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96e4b1a",
  null
  
)

export default component.exports